export const LoaderSpinner = ({
    width = "50",
    height = "50",
    border = "6",
    parentHeight = "h-full",
    type = "default",
    colorSpinner = "green",
    detached,
    testId
}) => {
    const getColorClassname = {
        "green": "green-spinner-view",
        "blue": "blue-spinner-view",
        "yellow": "yellow-spinner-view",
        "purple": "purple-spinner-view",
        "red": "red-spinner-view",
        "black": "black-spinner-view",
        "gray": "gray-spinner-view"
    }
    const currentSpinnerColorClass = getColorClassname[colorSpinner] ? getColorClassname[colorSpinner] : "green";
    return (
        <div className={`flex justify-center items-center ${type === "cron" ? "h-auto w-auto" : `${parentHeight} w-full`} ${detached ? "absolute": ""}`}>
            <div
                className={`rounded-full animate-spin ${currentSpinnerColorClass}`}
                data-testid={testId}
                style={{
                    width: `${width}px`,
                    height: `${height}px`,
                    borderWidth: `${border}px`
                }}
            ></div>
        </div>
    )
}